export default __webpack_public_path__ + "static/media/warehouse.e968bc73.svg";